import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function SuccessOverlay({
  message = 'Payment successful! Your premium is active.',
  duration = 2000,         
  onDone,                   
}) {
  useEffect(() => {
    const t = setTimeout(() => onDone?.(), duration);
    return () => clearTimeout(t);
  }, [duration, onDone]);

  return createPortal(
    <div
      className="fixed inset-0 z-[2147483647] bg-black/40"
      role="status"
      aria-live="polite"
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-white rounded-xl px-5 py-4 shadow flex items-center gap-2">
          <span aria-hidden>✅</span>
          <p className="text-sm font-medium">{message}</p>
        </div>
      </div>
    </div>,
    document.body
  );
}
